import { ModuleWithProviders, NgModule, Type } from '@angular/core';
import { TrackingIntegrationService } from '@nimbus-library/features/tracking/services/tracking-integration.service';
import { TrackingScriptService } from '@nimbus-library/features/tracking/services/tracking-script.service';
import { ITrackingConfigurationService } from '@nimbus-library/features/tracking/services/i-tracking-configuration.service';

@NgModule({
  imports: [],
  providers: [TrackingIntegrationService, TrackingScriptService],
})
export class TrackingRootModule {}

export class TrackingModule {
  public static forRoot(trackingConfigurationService: Type<ITrackingConfigurationService>): ModuleWithProviders<TrackingModule> {
    return {
      ngModule: TrackingRootModule,
      providers: [{ provide: ITrackingConfigurationService, useClass: trackingConfigurationService }],
    };
  }
}
